import { gql } from "@apollo/client";

export default gql`
  query getMeetingUsingGoogleMeetUrlQuery($googleMeetUrl: String!) {
    meeting(googleMeetUrl: $googleMeetUrl) {
      id
    }
  }
`;
